export default __webpack_public_path__ + "static/media/ic-publish-1.7ff25dcc.svg";